/**
 *= require menu.js
 *= require notifications.js
 *= require error_handler.js
 *= require form.js
 *= require global_msg.js
 *= require_self
 */

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/** TOOLTIPS */
$('.js-tooltip').tooltip();

/**
 * Get a nested value, or return a default value if it doesn't exist
 * Checks inherited properties by default (does not check hasOwnProperty(key), if needed we should extend the method)
 *
 * @param  {object} src     The source object
 * @param  {string} input   A string of keys, separated by periods ("a.b.c" will be translated into [a,b,c])
 * @param  {mixed}  def_val The value to be returned if the src object does not have this value set. undefined by default
 *
 * @return {mixed}
 *
 * @author Aleš Bolka <ales@easistent.com>
 */
var object_get = function (src, input, def_val) {
    def_val = def_val === undefined ? undefined : def_val;
    var keys;

    if (typeof input !== 'string') {
        return def_val;
    }
    keys = input.split('.');

    for (var ii = 0; ii < keys.length; ii++) {
        if (src === undefined) {
            return def_val;
        }

        src = src[keys[ii]];
    }
    return src === undefined ? def_val : src;
}

/**
 * Toggle the lock on a form - locked inputs are turned to readonly, buttons are disabled
 *
 * @param  {DOM node}   form    NOT a jQuery variable, pure DOM element!
 * @param  {boolean}    lock    Do we wish to lock the form (true) or unlock it (false, default)
 *
 * @return void
 *
 * @author Aleš Bolka <ales@xooltime.com>
 */
function toggleFormLock(form, lock) {
    var elements = form.elements;;
    var ii;
    var lock = lock || false;

    for (ii = 0; ii < elements.length; ii++) {
        elements[ii].readOnly = lock;
        elements[ii].disabled = lock;
    }
}

/**
 * Insert an alert message into the given target
 *
 * @param  {jQuery}  $target Where do we want the alert
 * @param  {string}  text    The text to insert
 * @param  {string}  type    The class of the alert (determines the colour)
 * @param  {integer} timeout The time in milisecond after which the alert dissapears - if 0 or not given, will remain permanently
 *
 * @return {void}
 *
 * @author Aleš Bolka <ales@xooltime.com>
 */
function showMessage($target, text, type, timeout) {
    var $message;
    timeout = timeout || 0;

    if (!text.length || !type.length || !$target.length) {
        return 0;
    }

    $message = $('<div class="alert full-width alert-' + type + '">' + text + '</div>');
    $message.appendTo($target.html(''));

    if (timeout > 0) {
        setTimeout(function() {
            $message.remove();
        }, timeout);
    }
}

/**
 * Show info message
 * @param  string   message
 * @param  boolean  delay
 * @return {void}
 */
var showInfo = function (message, timeout, icon) {

    icon = icon || 'check';

    if (!message) {
        return;
    }

    globalMsg.show(
        '<div class="alert alert-info">' +
            '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>' +
            '<span class="icon icon-' + icon + '"></span>&nbsp;' +
            '<strong>' + message + '</strong>' +
        '</div>'
    );

    if (timeout) {
        globalMsg.hideOnTimeout();
    }
};

/**
 * mark inputs with border, append errors texts
 * @param  {mixed} errfields
 * @param  {jQuery} $container usually form element
 * @return {void}
 * @author Andraz <andraz@easistent.com>
 */
var showErrfields = function (errfields, selector, $container, timeout) {

    if (errfields === undefined) {
        return;
    }

    if (typeof selector !== 'object') {
        selector = selector || '.errfields';
    }

    var html = '';
    $container = ($container !== undefined && $container.length) ? $container : $(document);

    /**
     * Split name
     * @param  {string} input_name
     * @return {array}
     * @author Andraz <andraz@easistent.com>
     */
    var getNameAndKey = function (input_name) {

        if (typeof input_name !== 'string') {
            return ['', ''];
        }


        var name_el = input_name.split('.'); // input.n = [input, n]
        var name = name_el[0];
        var key = name_el[1];

        return name_el;
    };

    /**
     * Find from group and add has-error class
     * @param  {string} name
     * @param  {string|undefined} key
     * @return {jQuery}
     * @author Andraz <andraz@easistent.com>
     */
    var inputHasError = function (name, key) {

        var $input;

        if (key !== undefined) {
            $input = $container.find('input[name="' + name + '[]"], textarea[name="' + name + '[]"], .error-for-' + name).eq(key);
        } else {
            $input = $container.find('input[name="' + name + '"], textarea[name="' + name + '"], .error-for-' + name);
        }

        if ($input.length === 0) {
            $input = $('[data-name=' + name + ']');
        }
        // add class to .form-group or parent
        $formGroup = $input.closest('.form-group');
        if ($formGroup.length === 0) {
            $formGroup = $input.parent('div');
        }

        $formGroup.addClass('has-error');

        if ($input.hasClass('select2-hidden-accessible')) {
            $input.next('.select2').addClass('has-error');
        }

        return $formGroup;
    };

    var labelHasError = function (name) {
        $container.find('[data-label=' + name + ']').addClass('label-has-error');
    };

    /**
     * Fill help block for input
     * @param  {jQuery} $formGroup
     * @param  {string} error
     * @return {void}
     * @author Andraz <andraz@easistent.com>
     */
    var fillHelpBlock = function ($formGroup, error) {
        var $helpBlock = $formGroup.find('.help-block');

        if ($helpBlock.length === 0) {
            $helpBlock = $('<span>', {'class': 'help-block'}).appendTo($formGroup);
        }

        $helpBlock.html(error).removeClass('hidden');
    };

    var toHtml = function (errors) {

        if (errors instanceof Object) {
            var html = '';
            $.each(errors, function (key, value) {
                html += toHtml(value);
            });

            return html;
        }

        return '<p>' + errors + '<p>';
    };

    $.each(errfields, function (name, error) {

        var nameParts = getNameAndKey(name);
        var $formGroup;

        if (nameParts === false) {
            return;
        }

        $formGroup = inputHasError(nameParts[0], nameParts[1]);
        fillHelpBlock($formGroup, error);
        labelHasError(nameParts[0]);

        html += toHtml(error);
    });

    showDanger(html, timeout);
}

var hideErrfields = function (selector, $container) {

    $container = $container || $(document);
    globalMsg.hide();

    $container.find('.has-error').removeClass('has-error');
    $container.find('.label-has-error').removeClass('label-has-error');
    $container.find('.help-block').text('');
}

// LOADER SECTION
var loaderTimeoutId;
function showLoader(txt) {
    var $loader = $('#loader-wrapper');
    var $loaderText = $('#loader-text h3');
    if (txt === undefined) {
        txt = '';
    }
    clearTimeout(loaderTimeoutId);
    loaderTimeoutId = setTimeout(function () {
        $loaderText.html(txt);
        $loader.show();
    }, 2000);
}

function hideLoader() {
    clearTimeout(loaderTimeoutId);
    $('#loader-wrapper').hide();
}

function appendLoader(parent) {
    var loader_html = $('#loader-wrapper').html();
    loader = $(loader_html).addClass('removable').wrap('<p>').parent().html();
    $(parent).append(loader);
}

function removeLoader() {
    $('.loader-center-wrapper.removable').remove();
}

$('body').on('click', '.js-prevent-default', function (e) {
    e.preventDefault();
});

var redirectOnError = function (statusCode) {
    window.location = '/error/' + statusCode;
};

/**
 * Equivalent to Array::filter, only for objects.
 * It's a stand alone function, because it's a bad idea
 * to extend the base object prototype
 *
 * @param  {Object}   obj
 * @param  {Function} callback
 *
 * @return object
 *
 * @author Blaž Pečnik <blaz@easistent.com>
 */
var filterObject = function (obj, callback) {
    var result = {},
        value,
        key;

    for (key in obj) {
        value = obj[key];
        if (callback(value, key) !== false) {
            result[key] = value;
        }
    }

    return result;
};

/**
 * Formats the kendo datepicker input value
 * to the standard mysql date format
 *
 * @param  jQuery_object $kendo_datepicker
 *
 * @return string "Y-m-d"
 *
 * @author Blaž Pečnik <blaz@easistent.com>
 */
var getKendoDbDate = function ($kendo_datepicker, format) {
    return getKendoDate($kendo_datepicker, 'yyyy-MM-dd');
};

var getKendoDate = function ($kendo_datepicker, date_format) {
    var kendo_date = $kendo_datepicker.data('kendoDatePicker').value();
    return kendo.toString(kendo_date, date_format);
};

/**
 * Default ajax setup
 * Status Codes
 * 461: forbidden document access
 */
$.ajaxSetup({
    statusCode: {
        461: function (jqXhr) {
            redirectOnError(jqXhr.status);
        }
    }
});

/**
 * Custom checkbox
 *
 * @author Blaž Pečnik <blaz@easistent.com>
 */
$('body').on('click', '.checkbox-input-label', function () {
    $(this).find('.checkbox-input')
        .toggleClass('checked')
        .trigger('change');
});

/**
 * Disabled or enable a input
 *
 * @param  jQuery $element
 * @param  bool   disabled
 *
 * @author Blaž Pečnik <blaz@easistent.com>
 */
var inputDisabled = function ($element, disabled) {
    $element.prop('disabled', disabled).toggleClass('disabled', disabled);
};


/**
 * Show info message
 * @param  string   message
 * @param  boolean  delay
 * @return {void}
 */
var showInfo = function (message, timeout) {

    if (!message) {
        return;
    }

    globalMsg.show(
        '<div class="alert alert-info">' +
            '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>' +
            '<span class="icon icon-check"></span>&nbsp;' +
            '<strong>' + message + '</strong>' +
        '</div>'
    );

    if (timeout) {
        globalMsg.hideOnTimeout();
    }
};

/**
 * Show success message
 * @param  string  message
 * @param  boolean  delay
 * @return {void}
 * @author Andraz <andraz@easistent.com>
 */
var showSuccess = function (message, timeout) {

    if (!message) {
        return;
    }

    globalMsg.show(
        '<div class="alert alert-success">' +
            '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>' +
            '<span class="icon icon-check"></span>&nbsp;' +
            '<strong>' + message + '</strong>' +
        '</div>'
    );

    if (timeout) {
        globalMsg.hideOnTimeout();
    }
};

/**
 * Show danger message
 * @param  string  message
 * @return {void}
 * @author Andraz <andraz@easistent.com>
 */
var showDanger = function (message, timeout) {

    if (!message) {
        return;
    }

    globalMsg.show(
        '<div class="alert alert-danger">' +
            '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>' +
            // '<span class="icon icon-cancel"></span>&nbsp;' +
            message +
        '</div>'
    );

    if (timeout) {
        globalMsg.hideOnTimeout();
    }
};

function version_compare(v1, v2, operator) {
    //       discuss at: http://phpjs.org/functions/version_compare/
    //      original by: Philippe Jausions (http://pear.php.net/user/jausions)
    //      original by: Aidan Lister (http://aidanlister.com/)
    // reimplemented by: Kankrelune (http://www.webfaktory.info/)
    //      improved by: Brett Zamir (http://brett-zamir.me)
    //      improved by: Scott Baker
    //      improved by: Theriault
    //        example 1: version_compare('8.2.5rc', '8.2.5a');
    //        returns 1: 1
    //        example 2: version_compare('8.2.50', '8.2.52', '<');
    //        returns 2: true
    //        example 3: version_compare('5.3.0-dev', '5.3.0');
    //        returns 3: -1
    //        example 4: version_compare('4.1.0.52','4.01.0.51');
    //        returns 4: 1

    this.php_js = this.php_js || {};
    this.php_js.ENV = this.php_js.ENV || {};
    // END REDUNDANT
    // Important: compare must be initialized at 0.
    var i,
    x,
    compare = 0,
    // vm maps textual PHP versions to negatives so they're less than 0.
    // PHP currently defines these as CASE-SENSITIVE. It is important to
    // leave these as negatives so that they can come before numerical versions
    // and as if no letters were there to begin with.
    // (1alpha is < 1 and < 1.1 but > 1dev1)
    // If a non-numerical value can't be mapped to this table, it receives
    // -7 as its value.
    vm = {
        'dev'   : -6,
        'alpha' : -5,
        'a'     : -5,
        'beta'  : -4,
        'b'     : -4,
        'RC'    : -3,
        'rc'    : -3,
        '#'     : -2,
        'p'     : 1,
        'pl'    : 1
    },
    // This function will be called to prepare each version argument.
    // It replaces every _, -, and + with a dot.
    // It surrounds any nonsequence of numbers/dots with dots.
    // It replaces sequences of dots with a single dot.
    //    version_compare('4..0', '4.0') == 0
    // Important: A string of 0 length needs to be converted into a value
    // even less than an unexisting value in vm (-7), hence [-8].
    // It's also important to not strip spaces because of this.
    //   version_compare('', ' ') == 1
    prepVersion = function(v) {
        v = ('' + v)
        .replace(/[_\-+]/g, '.');
        v = v.replace(/([^.\d]+)/g, '.$1.')
        .replace(/\.{2,}/g, '.');
        return (!v.length ? [-8] : v.split('.'));
    },
    // This converts a version component to a number.
    // Empty component becomes 0.
    // Non-numerical component becomes a negative number.
    // Numerical component becomes itself as an integer.
    numVersion = function(v) {
        return !v ? 0 : (isNaN(v) ? vm[v] || -7 : parseInt(v, 10));
    };
    v1 = prepVersion(v1);
    v2 = prepVersion(v2);
    x = Math.max(v1.length, v2.length);
    for (i = 0; i < x; i++) {
        if (v1[i] == v2[i]) {
            continue;
        }
        v1[i] = numVersion(v1[i]);
        v2[i] = numVersion(v2[i]);
        if (v1[i] < v2[i]) {
            compare = -1;
            break;
        } else if (v1[i] > v2[i]) {
            compare = 1;
            break;
        }
    }
    if (!operator) {
        return compare;
    }

    // Important: operator is CASE-SENSITIVE.
    // "No operator" seems to be treated as "<."
    // Any other values seem to make the function return null.
    switch (operator) {
        case '>':
        case 'gt':
        return (compare > 0);
        case '>=':
        case 'ge':
        return (compare >= 0);
        case '<=':
        case 'le':
        return (compare <= 0);
        case '==':
        case '=':
        case 'eq':
        return (compare === 0);
        case '<>':
        case '!=':
        case 'ne':
        return (compare !== 0);
        case '':
        case '<':
        case 'lt':
        return (compare < 0);
        default:
        return null;
    }
}

/**
 * Check if the given key is on the "do-not-trigger-keyup" blacklist (used with searches)
 *
 * @param  {integer}  key
 *
 * @return {Boolean}
 *
 * @author Aleš Bolka <ales@easistent.com>
 */
function isBlacklisted (key) {
    return [
        9, // tab
        13, // return
        16, // shift
        17, // ctrl,
        18, // alt
        27, // esc
        37, 38, 39, 40 // arrow keys
    ].indexOf(key) > -1;
}

$.fn.extend({

    /**
     * Constrain text inputs to integer values.
     *
     * @author Blaž Pečnik <blaz@easistent.com>
     * @param  {string} selector [description]
     * @return {[type]}          [description]
     */
    integerInput: function (selector) {

        /**
         * Check is valdi key.
         *
         * @author Blaž Pečnik <blaz@easistent.com>
         *
         * @param  {int}  key
         *
         * @return {Boolean}
         */
        var isValidKey = function (key) {

            // Numbers 0 - 9.
            if (key >= 48 && key <= 57) {
                return true;
            }

            // Numpad-numbers 0 - 9.
            if (key >= 96 && key <= 105) {
                return true;
            }

            // Backsapce, left-arrow, right-arrow, delete.
            return [8, 37, 39, 46].indexOf(key) >= 0;
        };

        $(this).on('keydown', selector || '', function (e) {
            if (e.keyCode === 13) {
                $(this).blur(); // focusout on enter
            } else if (!isValidKey(e.keyCode)) {
                e.preventDefault();
            }
        });
    },
});

var master_header_height = $('#master-header').height() || 0;
$.fn.extend({
    /**
     * Custom scroller method
     * Scrolls the top of the element to the top of the html body (inner scrolling will break it)
     *
     * @param  {integer} offset - How much to offset the scroll by px (positive = additional space, negative - less space from the top of the screen)
     * @param  {integer} index  - which element in the collection to use as the scroll reference (first by default)
     *
     * @return {self}
     *
     * @author Aleš Bolka <ales@easistent.com>
     */
    scrollIntoView: function (offset, index) {
        var el;
        index = parseInt(index, 10) || 0;
        el = this.eq(index);
        offset = parseInt(offset, 10) || 10;

        $('html, body').animate({
            scrollTop: el.offset().top - master_header_height - offset
        });

        return this;
    }
});


/**
 * lodash debounce
 * @author Blaž Pečnik <blaz@easistent.com>
 * @param  {function} func
 * @param  {number} timeout
 * @return {function}
 */
 var debounce = function (func, timeout) {
	var timeoutId;
	return function () {
		var context = this;
		var args = arguments;
		clearTimeout(timeoutId);
		timeoutId = setTimeout(function () {
			func.apply(context, args);
		}, timeout);
	}
}

/**
 * lodash deburr
 *
 * replace šumniki with normal letters
 *
 * @author Blaž Pečnik <blaz@easistent.com>
 * @param  {function} func
 * @param  {number} timeout
 * @return {function}
 */
var deburr = (function () {

    var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
        '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
        '\xc7': 'C', '\xe7': 'c',
        '\xd0': 'D', '\xf0': 'd',
        '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
        '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
        '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
        '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
        '\xd1': 'N', '\xf1': 'n',
        '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
        '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
        '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
        '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
        '\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
        '\xc6': 'Ae', '\xe6': 'ae',
        '\xde': 'Th', '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
        '\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
        '\u0106': 'C', '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
        '\u0107': 'c', '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
        '\u010e': 'D', '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
        '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
        '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
        '\u011c': 'G', '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
        '\u011d': 'g', '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
        '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
        '\u0128': 'I', '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
        '\u0129': 'i', '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
        '\u0134': 'J', '\u0135': 'j',
        '\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
        '\u0139': 'L', '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
        '\u013a': 'l', '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
        '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
        '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
        '\u014c': 'O', '\u014e': 'O', '\u0150': 'O',
        '\u014d': 'o', '\u014f': 'o', '\u0151': 'o',
        '\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
        '\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
        '\u015a': 'S', '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
        '\u015b': 's', '\u015d': 's', '\u015f': 's', '\u0161': 's',
        '\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
        '\u0163': 't', '\u0165': 't', '\u0167': 't',
        '\u0168': 'U', '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
        '\u0169': 'u', '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
        '\u0174': 'W', '\u0175': 'w',
        '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
        '\u0179': 'Z', '\u017b': 'Z', '\u017d': 'Z',
        '\u017a': 'z', '\u017c': 'z', '\u017e': 'z',
        '\u0132': 'IJ', '\u0133': 'ij',
        '\u0152': 'Oe', '\u0153': 'oe',
        '\u0149': "'n", '\u017f': 's'
    };

    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var rsComboMarksRange = '\\u0300-\\u036f';
    var reComboHalfMarksRange = '\\ufe20-\\ufe2f';
    var rsComboSymbolsRange = '\\u20d0-\\u20ff';
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsCombo = '[' + rsComboRange + ']';
    var reComboMark = RegExp(rsCombo, 'g');
    var deburrLetter = basePropertyOf(deburredLetters);

    function basePropertyOf(object) {
        return function (key) {
            return object == null ? undefined : object[key];
        };
    }

    return function (string) {
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    };
})();

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * clamp(-10, -5, 5)
 * // => -5
 *
 * clamp(10, -5, 5)
 * // => 5
 */
function clamp(number, lower, upper) {
    number = +number
    lower = +lower
    upper = +upper
    lower = lower === lower ? lower : 0
    upper = upper === upper ? upper : 0
    if (number === number) {
        number = number <= upper ? number : upper
        number = number >= lower ? number : lower
    }
  return number
}

/**
 * Refresh page and show success
 *
 * @author Blaž Pečnik <blaz@easistent.com>
 * @param  {[type]} msg [description]
 */
function refreshAndSuccess(msg) {
    var $form = $('#js-dv-flash-success');
    $form.find('input[name="message"]').val(msg);
    $form.submit();
}

/**
 * Basic lazyLoader. This version works only for scrolling the whole window.
 * Upgrade, if scrolling in a div is needed.
 *
 * @param  string   trigger   trigger element selector. This element should be at the bottom of the scrollable list
 * @param  integer  threshold override default threshold for triggering new requests. Default: 1000px
 * @return boolean
 */
function lazyLoad(trigger, threshold) {

    trigger = trigger || '.lazy-load-trigger';
    threshold = threshold || 1000;

    trigger = document.querySelector(trigger);

    if (trigger === undefined || trigger === null) {
        return false;
    }

    var height = window.innerHeight;
    var offset = trigger.getBoundingClientRect().top;

    return height - offset > -threshold
}
